import { string, object } from 'yup';

const schema = object().shape({
  name: string().required('requiredField'),
  email: string().required('requiredField').email('invalidEmailAddress'),
  phone: string().required('requiredField').matches(/^[0-9]+$/, 'onlyNumbers'),
  message: string().required('requiredField')
});

export default schema;